import React from 'react';
import { styled } from '@glitz/react';
import { ToggleableField } from 'Shared/Accordion';
import CheckoutUpdateResultType from '../Pages/Checkout/CheckoutUpdateResult.type';
import FeedbackWrapper from 'Shared/FeedbackWrapper';
import { Close16x16 } from 'Shared/Icons/Close';
import Input from 'Shared/Fields/Text';
import FeedbackButton, { ButtonTheme } from 'Shared/Button/Feedback';

const Remove = styled(FeedbackWrapper, {
  marginRight: '6px'
});

const Content = styled.div({
});

const DiscountListWrap = styled.div({
  display: 'flex',
  flexDirection: 'column',
})

const Item = styled.div({
  position: 'relative',
  display: 'flex',
  justifyContent: 'space-between',
});

const CodeItem = styled.span({
  fontWeight: 'bold',
});

type PropType = {
  header: string;
  buttonText: string;
  placeholderText: string;
  discountCodes: string[];
  addDiscountCode: (value: string) => Promise<CheckoutUpdateResultType>;
  removeDiscountCode: (value: string) => Promise<void>;
  isMobile?: boolean;
  errorCodes?: string[];
  defaultError: string;
};

type StateType = {
  isOpen?: boolean;
  showMessage?: boolean;
  value: string;
  isValid?: boolean;
};

export default class DiscountCode extends React.Component<PropType, StateType> {
  constructor(props: PropType) {
    super(props);
    this.state = {
      isOpen: props.discountCodes?.length > 0,
      showMessage: false,
      value: '',
      isValid: props.errorCodes === null || props.errorCodes.length < 1,
    };
  }

  async removeDiscountCode(code: string) {
    const action = async () => {
      await this.props.removeDiscountCode(code);
      return Promise.resolve(null);
    };

    this.setState({
      showMessage: false,
    });

    try {
      const promise = action();
      await promise;
    } catch (e) {
      console.log(e);
    }
  }

  async setDiscountCode() {
    const code = this.state.value;

    const action = async () => {
      try {
        const { success } = await this.props.addDiscountCode(code);
        if (success) {
          return Promise.resolve();
        } else {
          return Promise.reject(null);
        }
      } catch (e) {
        console.debug(e);
      }
    };

    try {
      const promise = action();
      await promise;

      if (this.props.discountCodes.filter(d => d.toLowerCase() === code.toLocaleLowerCase())?.length === 0) {
        this.setState({
          showMessage: true,
          isValid: this.props.errorCodes === null || this.props.errorCodes.length < 1,
        });
        return Promise.reject(null);
      } else {
        this.setState({
          showMessage: false,
          value: '',
          isValid: true,
        });
        return Promise.resolve();
      }
    } catch (e) {
      console.log(e);
      return Promise.reject(null);
    }
  }

  onChange(inValue: string) {
    const oldValidValue = this.state.isValid;
    this.setState({
      value: inValue.toUpperCase().trim() || '',
      isValid: inValue.trim() === '' ? true : oldValidValue
    });
  }

  onToggle = () => this.setState({ isOpen: !this.state.isOpen });
  render() {
    const { value } = this.state;
    const { discountCodes, isMobile } = this.props;

    const discountList = discountCodes?.map((discountCode, i) => {
      const data = (
        <Item key={i}>
          <Remove flexInnerDiv feedback={() => this.removeDiscountCode(discountCode)}>
            <Close16x16 />
          </Remove>
          <CodeItem>
            {discountCode}
          </CodeItem>
        </Item>
      );
      return data;
    });

    const Header =
      this.props.discountCodes?.length > 0 ? (
        this.props.header + " (" + this.props.discountCodes.length + ")"
      ) : (
        this.props.header
      );

    return (
      <ToggleableField iconWidth='16px' upperCaseHeading headerFontSize='14px' noBorder extraPadding header={Header} isOpen={this.state.isOpen} onToggle={this.onToggle}>
        <Content>
          {discountList &&
            <DiscountListWrap
              css={{
                ...(this.state.isOpen && {
                  marginTop: '8px'
                })
              }}
            >
              {discountList}
            </DiscountListWrap>
          }
          <styled.Div
            css={{
              display: 'flex',
              ...(this.state.isOpen && {
                marginTop: '14px'
              })
            }}
          >
            <Input
              css={{
                flexGrow: 1,
                paddingRight: '12px'
              }}
              value={value}
              invalid={!this.state.isValid}
              errorText={this.state.showMessage && (this.props.errorCodes ? this.props.errorCodes.join(', ') : this.props.defaultError)}
              onChange={e => this.onChange(e.currentTarget.value)}
              placeholder={this.props.placeholderText}
            />
            <FeedbackButton
              onClick={this.setDiscountCode.bind(this)}
              theme={ButtonTheme.BlackToWhite}
              disabled={!value}
            >
              {this.props.buttonText}
            </FeedbackButton>
          </styled.Div>
        </Content>
      </ToggleableField>
    );
  }
}
